import { initSlider } from './slider';
import { initMenu } from './menu';

document.addEventListener('DOMContentLoaded', () => {
  initMenu({
    openButtonId: 'landing-menu',
    closeButtonId: 'landing-menu-close',
    listId: 'landing-menu-list',
    openedStateClass: 'landing-menu__menu-wrapper_opened',
    sectionLinksId: 'section-links',
  });

  initSlider({
    sliderContainerId: 'bots-slider',
    sliderPrevButtonClass: 'slider__arrow-prev',
    sliderNextButtonClass: 'slider__arrow-next',
    hideButtonClass: 'slider__arrow-hide',
  });
});
